//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UnLogin from '@/components/userPanel/UnLogin';
import HasLogin from '@/components/userPanel/HasLogin'; // client js begin

import util from '@tencent/vft-common/util'; // client js end

var hasCheckParamsForActionPay = false;
export default {
  name: 'UserPanel',
  components: {
    HasLogin: HasLogin,
    UnLogin: UnLogin
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (!hasCheckParamsForActionPay) {
      hasCheckParamsForActionPay = true;
      this.openMiniPay();
    }
  },
  methods: {
    openMiniPay: function openMiniPay() {
      var _this = this;

      var _onLogout, params, ptag, u, n, ntype, hlwactid, tab;

      if (util.getUrlParam('action') === 'pay') {
        ptag = util.getUrlParam('ptag');
        u = util.getUrlParam('u');
        params = {
          _source: 19
        };

        if (ptag) {
          params._pr = ptag;
        }

        n = util.getUrlParam('n');
        ntype = util.getUrlParam('ntype');
        hlwactid = util.getUrlParam('hlwactid');
        tab = util.getUrlParam('tab');
        n && (params.amount = n);
        ntype && (params.ntype = ntype);
        hlwactid && (params.actid = hlwactid);
        tab && (params.tab = tab);
        var login = window.txv.login; // eslint-disable-next-line

        if (login.isLogin() && u && login.getUin() != u) {
          _onLogout = function onLogout() {
            _this.openPay(params);

            login.removeLogoutCallback(_onLogout);
            _onLogout = null;
          };

          login.addLogoutCallback(_onLogout);
          login.logout();
        } else {
          this.openPay(params);
        }
      }
    }
  },
  reportModule: '开通面板'
};